"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_LABEL_POSITION = exports.ICON_LABEL_FONT_TYPE = exports.ICON_OPACITY = exports.ICON_SEGMENT = exports.ICON_KIND = exports.ICON_COLOR = exports.ICON_ID = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = __importDefault(require("styled-components"));
// genero version
const next_components_icon_n_1 = __importStar(require("@gerenciatd/next.components.icon-n"));
Object.defineProperty(exports, "ICON_ID", { enumerable: true, get: function () { return next_components_icon_n_1.ICON_ID; } });
Object.defineProperty(exports, "ICON_KIND", { enumerable: true, get: function () { return next_components_icon_n_1.ICON_KIND; } });
const next_utils_enums_segment_1 = require("@gerenciatd/next.utils.enums.segment");
Object.defineProperty(exports, "ICON_SEGMENT", { enumerable: true, get: function () { return next_utils_enums_segment_1.SEGMENT; } });
const next_utils_enums_colors_1 = require("@gerenciatd/next.utils.enums.colors");
Object.defineProperty(exports, "ICON_COLOR", { enumerable: true, get: function () { return next_utils_enums_colors_1.COLOR_DICTIONARY; } });
Object.defineProperty(exports, "ICON_OPACITY", { enumerable: true, get: function () { return next_utils_enums_colors_1.OPACITY; } });
const enums_1 = require("./enums");
Object.defineProperty(exports, "ICON_LABEL_FONT_TYPE", { enumerable: true, get: function () { return enums_1.ICON_LABEL_FONT_TYPE; } });
Object.defineProperty(exports, "ICON_LABEL_POSITION", { enumerable: true, get: function () { return enums_1.ICON_LABEL_POSITION; } });
// Styled compontent
const StyledIconLabel = styled_components_1.default.span `
  ${(props) => (props.labelColor ? `color:${props.labelColor};` : '')}
  ${(props) => (props.labelSize ? `font-size:${props.labelSize}px;` : '')}
`;
const IconLabel = (props) => {
    const { label, labelPosition, hideAcc, id, kind, iconSize, layoutSize, iconColor, labelSize, labelFont, labelColor, iconOpacity, labelOpacity, className, sizeCircular, segment, backgroundColor, custoObjectInfo, } = props;
    if (!id && !label) {
        return null;
    }
    const setFontLabelCss = (mySegment, mylabelFont) => {
        return ((labelFont && ` iconLabel_label-${mySegment}--${mylabelFont}`) ||
            ` iconLabel_label-${mySegment}--${enums_1.ICON_LABEL_FONT_TYPE.LIGHT}`);
    };
    const setFlexFlow = (labelPositionValue) => {
        switch (labelPositionValue) {
            case enums_1.ICON_LABEL_POSITION.RIGHT:
                return ' iconLabel_row-direction';
            case enums_1.ICON_LABEL_POSITION.LEFT:
                return ' iconLabel_row-direction iconLabel_row-direction--reverse';
            case enums_1.ICON_LABEL_POSITION.TOP:
                return ' iconLabel_column-direction iconLabel_column-direction--reverse';
            default:
                return ' iconLabel_column-direction';
        }
    };
    const flexCss = setFlexFlow(labelPosition);
    const hideAccClass = (hideAcc && ' hide-acc') || '';
    const finalLabel = label ? { __html: label } : null;
    let mySegment = (0, next_utils_enums_segment_1.getCssSegment)(segment);
    if (!mySegment) {
        mySegment = 'gp';
    }
    const colorOpacity = (0, next_utils_enums_colors_1.getColor)(labelColor, labelOpacity, mySegment);
    if (!colorOpacity) {
        return null;
    }
    let finalCssLabel = `iconLabel_label`;
    let editModal = null;
    let cssCustoEditable = '';
    if (custoObjectInfo) {
        cssCustoEditable = ' custo-editable';
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
    }
    const onClick = editModal || null;
    finalCssLabel = `${finalCssLabel}${setFontLabelCss(mySegment, labelFont)}${hideAccClass}`;
    return (react_1.default.createElement("span", { className: `iconLabel${flexCss}${cssCustoEditable}${className ? ` ${className}` : ''}`, onClick: onClick },
        id && (react_1.default.createElement(next_components_icon_n_1.default, { id: id, kind: kind, size: iconSize, color: iconColor, segment: mySegment, sizeCircular: sizeCircular, layoutSize: layoutSize, backgroundColor: backgroundColor, opacity: iconOpacity })),
        finalLabel && (react_1.default.createElement(StyledIconLabel, { labelColor: colorOpacity, className: finalCssLabel, labelSize: labelSize, dangerouslySetInnerHTML: finalLabel }))));
};
IconLabel.propTypes = {
    /**
     * {
     *  "info": "Literal que aparecerá junto al icono",
     *  "kind": "both",
     *  "beautifulName": "Texto",
     *  "injectComponent": ""
     * }
     */
    label: prop_types_1.default.string,
    /**
     * {
     *  "info": "Posición del literal con respecto al objeto",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    labelPosition: prop_types_1.default.oneOf([
        enums_1.ICON_LABEL_POSITION.TOP,
        enums_1.ICON_LABEL_POSITION.RIGHT,
        enums_1.ICON_LABEL_POSITION.BOTTOM,
        enums_1.ICON_LABEL_POSITION.LEFT,
    ]),
    /**
     * {
     *  "info": "Objeto que permite esconder o mostar un elemento de la accesibilidad",
     *  "kind": "playground",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    hideAcc: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Establece el icono que se va a utilizar",
     *  "kind": "both",
     *  "beautifulName": "Icono id",
     *  "injectComponent": ""
     * }
     */
    id: prop_types_1.default.oneOf(Object.values(next_components_icon_n_1.ICON_ID)),
    /**
     * {
     *  "info": "Selecciona el trazo del icono, algunos no existen para determinados iconos id",
     *  "kind": "both",
     *  "beautifulName": "Trazo",
     *  "injectComponent": ""
     * }
     */
    kind: prop_types_1.default.oneOf([next_components_icon_n_1.ICON_KIND.LIGHT, next_components_icon_n_1.ICON_KIND.MEDIUM, next_components_icon_n_1.ICON_KIND.SOLID]),
    /**
     * {
     *  "info": "Selecciona el color del icono",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    iconColor: prop_types_1.default.oneOf(Object.values(next_utils_enums_colors_1.COLOR_DICTIONARY)),
    /**
     * {
     *  "info": "Selecciona la opacidad del icono",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    iconOpacity: prop_types_1.default.oneOf(Object.values(next_utils_enums_colors_1.OPACITY)),
    /**
     * {
     *  "info": "Tamaño en px del icono",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    iconSize: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    /**
     * {
     *  "info": "Tamaño en px del texto",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    labelSize: prop_types_1.default.number,
    /**
     * {
     *  "info": "Tamaño en px del layout donde se inyectara el icono",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    layoutSize: prop_types_1.default.shape({
        w: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        h: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    }),
    /**
     * {
     *  "info": "Selecciona el color del literal",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    labelColor: prop_types_1.default.oneOf(Object.values(next_utils_enums_colors_1.COLOR_DICTIONARY)),
    /**
     * {
     *  "info": "Selecciona la opacidad del label",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    labelOpacity: prop_types_1.default.oneOf(Object.values(next_utils_enums_colors_1.OPACITY)),
    /**
     * {
     *  "info": "Selecciona la fuente del literal",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    labelFont: prop_types_1.default.oneOf(Object.values(enums_1.ICON_LABEL_FONT_TYPE)),
    /**
     * {
     *  "info": "Selecciona el segmento",
     *  "kind": "both",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    segment: prop_types_1.default.oneOf(Object.values(next_utils_enums_segment_1.SEGMENT)),
    /**
     * {
     *  "info": "Otorga un className adicional al elemento",
     *  "kind": "playground",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Otorga un color al background del icono circular",
     *  "kind": "playground",
     *  "beautifulName": "",
     *  "injectComponent": ""
     * }
     */
    backgroundColor: prop_types_1.default.oneOf(Object.values(next_utils_enums_colors_1.COLOR_DICTIONARY)),
};
IconLabel.defaultProps = {
    label: '',
    labelPosition: enums_1.ICON_LABEL_POSITION.BOTTOM,
    labelFont: enums_1.ICON_LABEL_FONT_TYPE.LIGHT,
    hideAcc: false,
    kind: next_components_icon_n_1.ICON_KIND.MEDIUM,
    iconColor: next_utils_enums_colors_1.COLOR_DICTIONARY.INHERIT,
    labelColor: next_utils_enums_colors_1.COLOR_DICTIONARY.INHERIT,
    iconOpacity: next_utils_enums_colors_1.OPACITY['100'],
    labelOpacity: next_utils_enums_colors_1.OPACITY['100'],
    iconSize: 16,
    layoutSize: {
        h: 'auto',
        w: 'auto',
    },
    labelSize: 16,
    segment: next_utils_enums_segment_1.SEGMENT.GP,
    className: '',
    backgroundColor: next_utils_enums_colors_1.COLOR_DICTIONARY.TRANSPARENT,
};
exports.default = IconLabel;
//# sourceMappingURL=index.js.map